import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        card: {
            padding: '10px',
            margin: '2px',
        },
        icon: {
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '20px',
            color: theme.palette.primary.main
        },
    }));
};
